import React, { Component } from "react";
import PropTypes from "prop-types";
import {Checkbox} from 'antd';

import "bootstrap/dist/css/bootstrap.css";
import {Link, withRouter} from "react-router-dom";
import {deleteMemberNotifications} from "../../api";
import {projectStatusCodeMap} from "../../components/ProjectStatusCodeMap";
import {isViewOnly} from "../../utils/UserInfo";

class Notification extends Component {

    async deleteNotification(id){
        this.props.refreshMemberNotifications(id);
    }

    render() {
      const {title, taskType,by, assetId, assetName, projectId, desc, projectStatus, formId, formName, taskSubType, section, NotificationId, selected} = this.props;


    if(taskType && taskType === 'ASSET') {
        return (
            <div style={{fontSize: "0.9rem"}}>
                <div><a href={`/${projectStatus}/${projectId}/assettasks/allsections/${assetId}/tasks`} style={{textTransform: "uppercase", fontWeight: "bold", color: "#0ca0da"}}
                           ><strong> Station: {title} </strong></a></div>
                <div><strong>Task Type: </strong> {section} - Asset Task ({taskSubType})</div>
                <div><strong>Asset Name:</strong> {assetName}</div>
                <div><strong>Sign Requested By :</strong> {by}</div>
                <div><p><strong>Task Description: </strong> {desc}</p></div>
            </div>
        );
    }else if(taskType && taskType === 'PROJECT_TASKS'){
        return (
            <div style={{fontSize: "0.9rem"}}>
                <div><a href={`/${projectStatus}/${projectId}/projecttasks`} style={{textTransform: "uppercase", fontWeight: "bold", color: "#0ca0da"}}><strong> Station: {title} </strong></a></div>
                <div><strong>Task Type: </strong> Project Task ({taskSubType})</div>
                <div><strong>Sign Requested By :</strong> {by}</div>
                <p><strong>Task Description: </strong> {desc}</p>
            </div>
        );

    }else if(taskType && taskType === 'PRE_ENERGIZATION_FORM'){
        return (
            <div style={{fontSize: "0.9rem"}}>
                <div><a href={`/${projectStatus}/${projectId}/peform/${formId}/showTasks`} style={{textTransform: "uppercase", fontWeight: "bold", color: "#0ca0da"}}><strong> Station: {title} </strong></a></div>
                <div><strong>Task Type: </strong> Pre-E Form Task</div>
                <div><strong>Form Name:</strong> {formName}</div>
                <div><strong>Sign Requested By :</strong> {by}</div>
                <p><strong>Task Description: </strong> {desc}</p>
            </div>
        );

    }else if(taskType && taskType === 'MEMEBER_NOTIFICATION'){
        return (
            <div style={{fontSize: "0.9rem"}}>
                <div><Link to={`/${projectStatus}/${projectId}/team`} style={{textTransform: "uppercase", fontWeight: "bold", color: "#0ca0da"}}><strong> Station: {title} </strong></Link></div>
                <p><strong>Team Member: </strong> {desc}  <Checkbox checked={selected} id={NotificationId} onClick={() => this.deleteNotification(NotificationId)}/></p>
            </div>
        );

    }else{
        return (
            <></>
        );
    }
  }
}


Notification.propTypes = {
  title: PropTypes.string,
  desc: PropTypes.string,
  action: PropTypes.string
}

export default withRouter(Notification);